<template>
  <div :class="{ 'has-invalid-state': state === false }">
    <FormulateInput
      v-bind="$attrs"
      v-on="$listeners"
      v-model="localValue"
      :type="type"
      :name="name"
      :label="label"
      :help="help"
      :placeholder="placeholder"
      :validation="validation"
      :error-behavior="errorBehavior"
      :value="localValue"
      @input="updateLocalValue"
      :disabled="isDisabled"
    />
  </div>
</template>

<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInput',
  mixins: [useReactiveModelMixin('value')],
  props: {
    type: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    help: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    validation: {
      type: [String, Object],
      default: ''
    },
    errorBehavior: {
      type: String,
      default: 'blur'
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    state: {
      type: Boolean,
      default: null
    }
  },
  created () {
    this.$root.$on('clearForm', () => {
      this.localValue = null
    })
  },
  methods: {
    updateLocalValue (newValue) {
      this.localValue = newValue
    }
  }
}
</script>

<style scoped>
.has-invalid-state >>> .formulate-input-element--select,
.has-invalid-state >>> .formulate-input-element--select select {
  border-color: #dc3545 !important;
}

.has-invalid-state >>> .formulate-input-element--select:focus,
.has-invalid-state >>> .formulate-input-element--select select:focus {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/nexum/components/inputs/NxInput.vue